module.exports = __webpack_public_path__ + "static/media/logo.a7fb9ee6.png";